// @ts-nocheck
export const OFFER_MODAL = "OFFER_MODAL";
export const SEND_OFFER = "SEND_OFFER";
